import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PrintPageType } from '@components/print-dialog/print-dialog.component';
import { PrintAlarmGroupService } from '@service/channel/print-alarm-groups/print-alarm-groups.service';
import { PrintGraphsService } from '@service/graphs/print-graphs.service';
import { PrintChannelsService } from '@service/print-channels-service/print-channels.service';
import { PrintMimicsService } from '@service/print-mimics.service';
import { PrintReposeGroupService } from '@service/print-repose-groups/print-repose-groups.service';
import { PrintSensorCableService } from '@service/sensor-cable-tag/print-sensor-cable-tag.service';
import { Vessel } from 'icreate/common/models/vessel';

@Component({
    selector: 'app-vessel-menu-print-dialog',
    templateUrl: './vessel-menu-print-dialog.component.html',
    styleUrl: './vessel-menu-print-dialog.component.css',
    standalone: false,
})
export class VesselMenuPrintDialogComponent implements OnInit {
    readonly CHANNELS_PRINT = PrintPageType.CHANNEL_SHEET;
    readonly MIMIC_PRINT = PrintPageType.SINGLE_MIMIC || PrintPageType.ALL_MIMICS;
    readonly SINGLE_MIMIC_PRINT = PrintPageType.SINGLE_MIMIC;
    readonly SENSOR_CABLE_TAG = PrintPageType.SENSOR_CABLE_TAG;
    readonly GRAPHS_PRINT = PrintPageType.GRAPHS;

    readonly printOptions = [
        { label: 'print.dialog.select.channel', value: PrintPageType.CHANNEL_SHEET },
        { label: 'print.dialog.select.repose-group', value: PrintPageType.REPOSE_GROUPS },
        { label: 'print.dialog.select.alarm-group', value: PrintPageType.ALARM_GROUPS },
        { label: 'print.dialog.select.sensor-cable-tag', value: PrintPageType.SENSOR_CABLE_TAG },
        { label: 'print.dialog.select.sensor-fu', value: PrintPageType.SENSOR_FU_PRINT },
        { label: 'print.dialog.select.mimics', value: PrintPageType.ALL_MIMICS },
        { label: 'print.dialog.select.graphs', value: PrintPageType.GRAPHS },
    ];

    selectedPrintOption = PrintPageType.CHANNEL_SHEET;
    isPrinting: boolean;

    constructor(
        private dialogRef: MatDialogRef<VesselMenuPrintDialogComponent>,
        private alarmGroupPrintService: PrintAlarmGroupService,
        private channelPrintService: PrintChannelsService,
        private mimicPrintService: PrintMimicsService,
        private reposeGroupPrintService: PrintReposeGroupService,
        private graphPrintService: PrintGraphsService,
        private sensorPrintService: PrintSensorCableService,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            shipyardId: string;
            iAPIVesselId: string;
            vessel: Vessel;
        }
    ) {}

    async ngOnInit() {}

    cancel() {
        this.dialogRef.close();
    }

    async print(): Promise<void> {
        if (!this.selectedPrintOption || this.isPrinting) {
            return;
        }

        this.isPrinting = true;

        try {
            let printResult: boolean | undefined = true;

            switch (this.selectedPrintOption) {
                case PrintPageType.CHANNEL_SHEET: {
                    printResult = await this.channelPrintService.triggerPrint(this.data.vessel);
                    break;
                }
                case PrintPageType.REPOSE_GROUPS: {
                    printResult = await this.reposeGroupPrintService.triggerPrint(this.data.vessel);
                    break;
                }
                case PrintPageType.ALARM_GROUPS: {
                    printResult = await this.alarmGroupPrintService.triggerPrint(this.data.vessel);
                    break;
                }
                case PrintPageType.ALL_MIMICS: {
                    printResult = await this.mimicPrintService.triggerPrint(this.data.vessel);
                    break;
                }
                case PrintPageType.GRAPHS: {
                    printResult = await this.graphPrintService.triggerPrint(this.data.vessel);
                    break;
                }
                case PrintPageType.SENSOR_CABLE_TAG: {
                    printResult = await this.sensorPrintService.triggerFCUPrint(this.data.vessel);
                    break;
                }
                case PrintPageType.SENSOR_FU_PRINT: {
                    printResult = await this.sensorPrintService.triggerFUPrint(this.data.vessel);
                    break;
                }
                default:
                    return;
            }

            if (printResult === false) {
                this.dialogRef.close();
            }
        } catch (error) {
            console.error('Error occurred during print execution:', error);
            this.dialogRef.close();
        } finally {
            this.isPrinting = false;
        }
    }

    onPrintOptionChange(value: PrintPageType): void {
        this.selectedPrintOption = value;
    }
}
